import styled, { css } from 'styled-components'

type TPressableProps = {
  $borderColor: string
  $borderWidth: number
  $isDisabled?: boolean
}

export const StyledScrollView = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  ${({ theme }) => css`
    border-color: ${theme.colors.foreground};
  `}
`

export const ActionsheetBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`

export const StyledPressable = styled.button<TPressableProps>`
  height: 48px;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
  padding: 10px;
  overflow: hidden;
  gap: 5px;
  border-radius: 8px;
  justify-content: space-between;
  background: none;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  ${({ $borderColor, $borderWidth, $isDisabled, theme }) => css`
    border-color: ${$isDisabled ? theme.colors.formBorderDisabled : $borderColor};
    border-width: ${$borderWidth}px;
    border-style: solid;
  `}
`

export const StyledBadge = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding-bottom: 5px;
`

type TMultiselectTextProps = {
  $isDisabled?: boolean
}

export const MultiselectText = styled.span<TMultiselectTextProps>`
  font-size: 16px;
  ${({ theme, $isDisabled }) => css`
    color: ${$isDisabled
      ? theme.colors.textFormDisabled
      : theme.colors.textForm};
  `}
`

export const MultiselectPlaceholder = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textDisabled};
`

export const MultiselectOptions = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.foreground};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
`

export const DropdownItem = styled.button`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`
